import { useEffect, Fragment } from "react";
import { useLocation, Redirect } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CourseDetails from "./CourseDetails";
import BreadCrumbs from "@components/breadcrumbs";
import { getCourseDetail } from "../action";
import "@styles/base/pages/app-ecommerce-details.scss";

const Details = () => {
  const location = useLocation();
  const courseId = location.state?.courseId;

  if (!courseId) return <Redirect to="/course-in-house" />;

  const dispatch = useDispatch();
  const course = useSelector((state) => state.courseInHouse);

  useEffect(() => {
    dispatch(
      getCourseDetail({
        courseId: courseId,
        inHouseFlag: true,
      })
    );
  }, []);

  return (
    <Fragment>
      <BreadCrumbs
        breadCrumbTitle="รายละเอียดหลักสูตร"
        breadCrumbParent="หลักสูตร"
        breadCrumbActive="รายละเอียดหลักสูตร"
      />
      <div className="">
        {course && course.courseDetail && Object.keys(course.courseDetail).length ? (
          <Card>
            <CardBody>
              <CourseDetails
                dispatch={dispatch}
                courseId={courseId}
                getCourseDetail={getCourseDetail}
                data={course.courseDetail}
                transactionCourseUser={course.transactionCourseUser}
              />
            </CardBody>
          </Card>
        ) : null}
      </div>
    </Fragment>
  );
};

export default Details;
